var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtencao({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2473 4689 c-167 -29 -321 -141 -436 -317 -51 -78 -1519 -2885 -1554 -2973 -43 -106 -63 -205 -63 -310 0 -126 13 -185 62 -289 59 -123 158 -221 288 -283 187 -89 31 -82 1790 -82 1759 0 1603 -7 1790 82 130 62 229 160 288 283 49 104 62 163 62 289 0 105 -20 204 -63 310 -20 50 -934 1807 -1404 2701 -173 329 -239 416 -386 511 -105 68 -256 99 -374 78z m136 -434 c84 -43 94 -60 877 -1561 414 -791 760 -1461 769 -1489 24 -68 25 -180 2 -223 -24 -43 -88 -89 -156 -110 -52 -16 -163 -17 -1541 -17 -1378 0 -1489 1 -1541 17 -68 21 -132 67 -156 110 -24 45 -22 156 4 228 16 44 1302 2518 1481 2849 67 125 152 211 210 211 13 0 36 -7 51 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 3394 c-45 -20 -87 -59 -111 -107 -19 -36 -19 -61 -17 -635 l3 -598 25 -37 c41 -61 92 -91 165 -95 54 -4 70 0 114 23 28 16 62 45 78 68 l28 40 3 599 c2 574 2 599 -17 635 -53 103 -172 150 -271 107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2459 1677 c-64 -34 -102 -93 -107 -167 -7 -98 31 -168 112 -206 106 -49 221 -16 277 80 27 45 30 58 27 118 -3 55 -9 75 -33 109 -41 58 -102 89 -175 89 -40 0 -70 -7 -101 -23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtencao);
export default __webpack_public_path__ + "static/media/atencao.244b6bbd173d3b9e0cfe6336ff869652.svg";
export { ForwardRef as ReactComponent };